import { createFileRoute } from '@tanstack/react-router'

import { useSessao } from '@/lib/sessao'

import { TelaDaVisaoGeral } from '@/components/gestor/visaoGeral/TelaDaVisaoGeral'

/*
 * `/gestor/painel`: a Visão geral. É onde abre o administrador e o primeiro
 * item do menu de todo cargo. A guarda de sessão mora na casca (`/gestor`); a
 * tela só pede os dados e mostra os atalhos das áreas que o cargo tem.
 */
function Painel() {
  const { data: sessao } = useSessao()
  return <TelaDaVisaoGeral abas={sessao?.abas ?? []} />
}

export const Route = createFileRoute('/gestor/painel')({ component: Painel })
